export default __webpack_public_path__ + "static/young-it-specialists-works-on-computers-47ad058507b5a2fc1889e04b4847f542.png";